import { Control, Controller } from "react-hook-form";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputBox from "@/components/Form/InputBox/InputBox";
import { EditSummaryFormType } from "./type";
import {
  CATEGORY_NAME,
  CATEGORY_DESC_NAME,
  CATEGORY_NAME_FR,
  CATEGORY_DESC_FR_NAME,
} from "./constant";

type ControlInputBoxType = {
  required?: boolean;
  isTextArea?: boolean;
  control: Control<EditSummaryFormType>;
  name:
    | typeof CATEGORY_NAME
    | typeof CATEGORY_DESC_NAME
    | typeof CATEGORY_NAME_FR
    | typeof CATEGORY_DESC_FR_NAME;
  showLabel: boolean;
  label: string;
  readonly?: boolean;
};

export default function ControlInputBox({
  name,
  control,
  required = false,
  isTextArea = false,
  showLabel,
  label,
  readonly,
}: ControlInputBoxType) {
  const { field } = useController({
    name,
    control,
    rules: { required: required },
  });
  const { t } = useTranslation();

  return (
    <>
      {showLabel && (
        <div className="formFieldLabel">
          <label htmlFor="input" aria-label={label}>
            {t(label)}
            {required ? <span className="requiredSymbol">*</span> : ""}
          </label>
        </div>
      )}
      <Controller
        name={field.name}
        control={control}
        rules={{ required }}
        render={({ field: { onChange, value, ...args } }) => {
          return (
            <>
              <InputBox
                id={CATEGORY_NAME}
                required={true}
                value={value || ""}
                onChange={onChange}
                isTextArea={isTextArea}
                readonly={readonly}
                {...args}
              />
            </>
          );
        }}
      />
    </>
  );
}
